import React from "react";
import DocumentHeading from "./DocumentHeader/DocumentHeading";
import DocumentBody from "./DocumentBody/DocumentBody";
import CustomModal from "../common/modal";
import "./index.scss";

function LegalDocument({ setShow, show, closeModal, documentData }) {
  const SwitchCaseHandler = (comp) => {
    switch (comp?.comp?.__component) {
      case "blog.heading":
        return <DocumentHeading blogHeading={comp?.comp?.blogHeading} />;
      // case "blog.blog-image":
      //   return (
      //     <BlogImage
      //       description={Any.imageDescription}
      //       image={Any.image?.data?.attributes?.url}
      //     />
      //   );
      case "blog.blog-rich-text":
        return <DocumentBody body={comp?.comp?.richtext} />;

      // case "blog.blog-video":
      //   return (
      //     <BlogVideo
      //       description={Any?.videoDescription}
      //       url={Any.blogVideo?.data?.attributes?.url}
      //     />
      //   );

      default:
        break;
    }
  };

  return (
    <>
      <CustomModal
        show={show}
        handleClose={closeModal}
        className="document-modal"
        title={documentData?.Title}
      >
        {documentData?.termsAndCondition?.map((comp, index) => (
          <SwitchCaseHandler key={index} comp={comp} />
        ))}
      </CustomModal>
    </>
  );
}

export default LegalDocument;
